export default "__VITE_ASSET__165de79c__"